<template>
  <Main />
  <div class="home-page">
    <CarSearch />
    <div class="carousel-container">
      <CarSlider />
    </div>
    <div class="content-container wow animate__animated animate__fadeIn">
      <About />
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import "animate.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Main from "@/components/Main.vue";
import About from "@/components/About.vue";
import CarSlider from "@/components/CarSlider.vue";
import CarSearch from "@/components/CarSearch.vue";

export default {
  name: "HomeView",
  components: {
    Main,
    About,
    CarSlider,
    CarSearch,
  },
  mounted() {
    // Initialize WOW.js for animations
    new WOW().init();
  },
};
</script>

<style scoped>
/* Styles for the carousel container */
.carousel-container {
  position: relative;
  margin-left: -15px; /* Offset Bootstrap container padding */
  margin-right: -15px;
  width: 100vw; /* Full viewport width */
  left: 50%;
  transform: translateX(-50%);
}

/* Base styles for the home page */
.home-page {
  width: 100%;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .carousel-container {
    margin-left: -10px; /* Reduced offset for mobile devices */
    margin-right: -10px;
  }
}
</style>
